var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Set restriction"}},[_c('v-select',{attrs:{"options":[{title: 'No restriction', id: -1}, ..._vm.options],"reduce":val => val.id,"serachable":false,"label":"title"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }